import { Popover } from "@mantine/core";
import { useState } from "react";

import type { Absence } from "~/modules/absence/api/absence/absenceTypes.ts";
import { AbsenceCard } from "~/modules/dashboard/components/TimeTrackingCalendar/AbsenceCard.tsx";
import { AbsenceRow } from "~/modules/dashboard/components/TimeTrackingCalendar/AbsenceRow.tsx";
import type { CalendarAbsenceActions } from "~/modules/dashboard/components/TimeTrackingCalendar/calendarDays.ts";

type Props = {
	absence: Absence;
	absenceName: string;
	absenceActions: CalendarAbsenceActions;
	size?: "sm";
	/** The card replaces the row in place, as in the day view, instead of opening in a popover. */
	inPlace?: boolean;
};

/**
 * The popover opens on a click, not on hover: it holds buttons, and a touch screen has no hover.
 * It closes on a click outside.
 */
export function AbsencePopoverBar({ absence, absenceName, absenceActions, size, inPlace }: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);
	const toggle = () => setIsOpen((wasOpen) => !wasOpen);
	const card = (
		<AbsenceCard absence={absence}
					 absenceName={absenceName}
					 absenceActions={absenceActions}
					 onClose={close} />
	);

	if (inPlace) {
		return isOpen ? card : (
			<AbsenceRow absenceName={absenceName}
						size={size}
						onClick={toggle} />
		);
	}

	return (
		<Popover opened={isOpen}
				 onChange={setIsOpen}
				 position="bottom-start">
			<Popover.Target>
				<div>
					<AbsenceRow absenceName={absenceName}
								size={size}
								isOpen={isOpen}
								onClick={toggle} />
				</div>
			</Popover.Target>
			<Popover.Dropdown className="!w-80 max-w-[calc(100vw-2rem)] !border-0 !bg-transparent !p-0 !shadow-none">
				{card}
			</Popover.Dropdown>
		</Popover>
	);
}
